/*
 * Search over the guide: chapter titles, their keywords and every caption.
 * Matching ignores case and Turkish letters (ı/i, ş/s, ğ/g, ü/u, ö/o, ç/c),
 * so "izin", "İZİN" and "izın" all find the leave chapters.
 */

export const normalizeText = (text) => String(text || '')
  .toLocaleLowerCase('tr')
  .replace(/ı/g, 'i')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '');

const termsOf = (query) => normalizeText(query).split(/\s+/).filter(Boolean);
const hasAll = (haystack, terms) => terms.every((term) => haystack.includes(term));

/**
 * Chapters matching `query`, best first: [{ chapter, beats }]. `beats` are the
 * steps whose caption matches, so the index can offer them directly.
 */
export const searchGuide = (timeline, t, query) => {
  const terms = termsOf(query);
  if (terms.length === 0) return null;
  const results = [];
  timeline.chapters.forEach((chapter) => {
    const head = normalizeText(`${t(`userGuide.chapters.${chapter.key}`)} ${t(`userGuide.keywords.${chapter.key}`)}`);
    const captions = chapter.beats.map((beat) => normalizeText(beat.caption));
    const beats = chapter.beats.filter((beat, index) => hasAll(captions[index], terms));
    const inHead = hasAll(head, terms);
    if (inHead || beats.length > 0 || hasAll(`${head} ${captions.join(' ')}`, terms)) {
      results.push({ chapter, beats, rank: inHead ? 0 : 1 });
    }
  });
  return results.sort((a, b) => a.rank - b.rank);
};
